<template>
    <div>
        <b-overlay spinner-type="none" :variant="'dark'" blur="5px" opacity=".6" :show="resultWindow.show"
                   @click="resultWindow.show = false, resultWindow.init = false">
            <!-- БЛОК Панель кнопок. Начало -->
            <ControlPanel v-if="!resultWindow.show" :icon="'mdi mdi-calculator'" :title="'Калькулятор заработной платы'"
                          :links="links">
                <template v-slot:left>
                    <a href="https://youtu.be/GmZB8JyFjX4" class="btn btn-sm btn-danger" target="_blank"><span
                            class="mdi mdi-youtube"></span> Краткая видеоинструкция</a>

                  <!--<b-button size="sm" class="ml-1 btn-warning" @click="modalSelf">Продлить подписку самостоятельно</b-button>-->
                </template>


                <!--<b-form-checkbox size="sm" class="mr-sm-2" value="1" unchecked-value="0" v-model="params.round">Округлять до тенге</b-form-checkbox>-->
                <b-button class="mr-sm-1" variant="primary" size="sm" @click="Calculator()"
                          :disabled="this.$store.state.wait.state"><span
                        class="mdi mdi-calculator"></span> Рассчитать
                </b-button>


                <b-button class="mr-sm-1" variant="secondary" size="sm" @click="Register()"><span
                        class="mdi mdi-format-list-bulleted-square"></span> Справочник регл. показателей
                </b-button>
                <b-button variant="info" size="sm" v-b-modal.modal-params><span class="mdi mdi-cogs"></span> Доп.
                    параметры
                </b-button>
            </ControlPanel>
            <!-- БЛОК Панель кнопок. Конец -->

          <!-- Окно Самостоятельная подписка -->
          <b-modal header-bg-variant="primary" header-text-variant="white" size="lg" scrollable id="modal-selfsubscribed"
                   centered
                   ok-disabled cancel-disabled
                   hide-header
          >
            <h5>Самостоятельная подписка</h5>
            <p>К сожалению, в ближайшие пару недель я не могу обслуживать калькулятор из-за болезни, ложусь в больницу с проблемами глаз.</p>
            <p>В связи с этим я предоставляю пользователям самостоятельно продлить себе подписку под честное слово.</p>
            <p>Вы можете оплатить подписку переводом на Kaspi или Homebank на номер +7 701 842-25-01 и продлить подписку в этом окне самостоятельно.</p>
            <div class="text-center mb-3">
              <b-button class="btn-dark" @click="doSS(1000)">Продлить на 1 месяц - 1000 тенге</b-button>
              <b-button class="btn-dark ml-1" @click="doSS(8000)">Продлить до конца 2025 года - 8000 тенге</b-button>
            </div>
            <p>После продления подписки обновите страницу, чтобы увидеть дату подписки в верхнем правом углу.</p>
          </b-modal>

          <!-- ОКНО Подписка. Начало -->
          <b-modal header-bg-variant="primary" header-text-variant="white" size="xl" scrollable id="modal-unsubscribed"
                   centered
                   ok-disabled cancel-disabled
                   hide-header
          >
            <h4 class="text-center">Ваша подписка на калькулятор зарплаты закончилась</h4>
            <div class="card mb-3">
              <div class="card-body">
                <div class="row">
                  <div class="col-5">
                    <h5 class="card-title">Стоимость подписки</h5>
                    <ul>
                      <li>1 месяц: 1 000 тенге</li>
                      <li>1 год: 10 000 тенге</li>
                      <li>Бессрочная подписка: 25 000 тенге</li>
                    </ul>
                  </div>
                  <div class="col-7">

                    <template v-if="new Date().getMonth() == 10 || new Date().getMonth() == 11">
                      <div class="p-2 bg-red text-white">
                        <h5>Акция!</h5>
                        <p>Оформите подписку с текущего дня до конца 2025 года всего за</p>
                        <p class="text-center h3">8 000 тенге</p>
                      </div>

                    </template>
                  </div>
                </div>
              </div>
            </div>

            <h5>Вы можете оплатить подписку следующими способами:</h5>
            <div class="row">
              <div class="col-2">
                <img src="https://culs.kz/calc/images/qr.png" alt="Kaspi QR" style="width: 100%">
              </div>
              <div class="col-10">
                <table class="table table-bordered table-sm">
                  <tbody>
                  <tr>
                    <td colspan="2">
                      ИП «Digital Solutions for Business» (Сутормин Вадим Викторович)
                    </td>
                  </tr>
                  <tr>
                    <th>Банк получатель</th>
                    <td>АО «Kaspi Bank»</td>
                  </tr>
                  <tr>
                    <th>БИК</th>
                    <td>CASPKZKA</td>
                  </tr>
                  <tr>
                    <th>ИИН</th>
                    <td>790124303100</td>
                  </tr>
                  <tr>
                    <th>Номер счета KZT</th>
                    <td>KZ54722S000005384601</td>
                  </tr>
                  <tr>
                    <th>Адрес</th>
                    <td>021700, Акмолинская область, г.Щучинск, ул.Тумар, 43</td>
                  </tr>
                  <tr>
                    <th>КБе</th>
                    <td>19</td>
                  </tr>
                  <tr>
                    <th>КНП</th>
                    <td>857 (платежи за информационные услуги)</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="alert alert-danger text-center">
              После оплаты уведомите о факте оплаты и на какой аккаунт продлевать подписку по номеру +7 701 842-25-01 (Whatsapp, звонок)
            </div>
            <!--<div class="text-center">
              <b-button  class="btn-warning" @click="modalSelf">Продлить подписку самостоятельно</b-button>
            </div>-->

            <template v-slot:modal-footer="{cancel}">
              <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span>
                Закрыть
              </b-button>
            </template>
          </b-modal>

            <!-- ОКНО Справочник регламентированных показателей. Начало -->
            <b-modal header-bg-variant="primary" header-text-variant="white" size="xl" scrollable id="modal-regl"
                     centered
                     ok-disabled
                     title="Регламентированные расчетные показатели" cancel-title-html="Закрыть" button-size="sm">

                <div class="table-responsive">
                    <table class="table table-14 table-sm table-bordered table-hover">
                        <thead>
                        <tr>
                            <th rowspan="3">Дата</th>
                            <th rowspan="3">МРП</th>
                            <th rowspan="3">МЗП</th>
                            <th colspan="16">Налоги, взносы, отчисления</th>
                        </tr>

                        <tr>
                            <th colspan="2">ОПВ</th>
                            <th colspan="2">ОПВР</th>
                            <th colspan="2">ОППВ</th>
                            <th colspan="2">ИПН</th>
                            <th colspan="2">СН</th>
                            <th colspan="2">СО</th>
                            <th colspan="2">ООСМС</th>
                            <th colspan="2">ВОСМС</th>
                        </tr>

                        <tr>
                            <th></th>
                            <th>Пределы</th>

                          <th></th>
                          <th>Пределы</th>
                            <th></th>
                            <th>Пределы</th>
                            <th></th>
                            <th>Пределы</th>
                            <th></th>
                            <th>Пределы</th>
                            <th></th>
                            <th>Пределы</th>
                            <th></th>
                            <th>Пределы</th>
                            <th></th>
                            <th>Пределы</th>
                        </tr>
                        </thead>
                        <tbody>

                        <template v-for="(item, index) of this.regl">
                            <tr :key="'regl' + index">
                                <td>{{ item.date_formatted }}</td>
                                <td>{{ item.mrp }}</td>
                                <td>{{ item.mzp }}</td>
                                <td>{{ item.opv_percent }}%</td>
                                <td>{{ item.opv_min + '–' + item.opv_max }}</td>

                                <td>{{ item.opvr_percent }}%</td>
                                <td>{{ item.opvr_min + '–' + item.opvr_max }}</td>

                              <td>{{ item.oppv_percent }}%</td>
                              <td>{{ item.oppv_min + '–∞' }}</td>

                                <td>{{ item.ipn_percent }}%</td>
                                <td>{{ item.ipn_min + '–∞' }}</td>

                                <td>{{ item.sn_percent }}%</td>
                                <td>{{ item.sn_min + '–∞' }}</td>

                                <td>{{ item.so_percent }}%</td>
                                <td>{{ item.so_min + '–' + item.so_max }}</td>

                                <td>{{ item.oosms_percent }}%</td>
                                <td>{{ item.oosms_min + '–' + item.oosms_max }}</td>

                                <td>{{ item.vosms_percent }}%</td>
                                <td>{{ item.vosms_min + '–' + item.vosms_max }}</td>

                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>


                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span>
                        Закрыть
                    </b-button>
                </template>
            </b-modal>

            <!-- ОКНО Справочник регламентированных показателей. Конец -->

            <!-- ОКНО Расчетный листок. Начало -->
            <b-modal header-bg-variant="primary" header-text-variant="white" size="xl" scrollable id="modal-payslip"
                     centered
                     ok-disabled
                     title="Печать расчетного листка" cancel-title-html="Закрыть" button-size="sm">
                <div id="printBodyRL" v-if="typeof result.payslip != 'undefined'">
                    <h4 class="text-center">Расчетный листок за
                        {{ result.payslip.month + ' ' + result.payslip.year + ' г.' }}</h4>
                    <table class="table table-sm table-bordered">
                        <tr>
                            <td>Организация: <strong>{{ result.payslip.org }}</strong></td>
                            <td>Подразделение: <strong></strong></td>
                        </tr>
                        <tr>
                            <td>Работник: <strong>{{ result.payslip.worker }}</strong></td>
                            <td>Должность: <strong>{{ result.payslip.workerfunction }}</strong></td>
                        </tr>
                    </table>


                    <table class="table table-sm table-bordered table-striped table-12" style="">
                        <tbody>
                        <tr>
                            <th>Вид</th>
                            <th>Период</th>
                            <th>Дни</th>
                            <th>Часы</th>
                            <th>Сумма</th>
                            <th>Вид</th>
                            <th>Период</th>
                            <th>Сумма</th>
                        </tr>
                        <tr>
                            <th colspan="5">Начислено</th>
                            <th colspan="3">Удержано</th>
                        </tr>

                        <tr v-for="(item, index) in result.payslip.salary" :key="index">
                            <td>{{ item.sum_name }}</td>
                            <td>{{ item.sum_period }}</td>
                            <td>{{ item.sum_days }}</td>
                            <td>{{ item.sum_hours }}</td>
                            <td class="text-right">{{ formatMoney(item.sum_value, 2) }}</td>
                            <td>{{ item.deduction_name }}</td>
                            <td>{{ item.deduction_period }}</td>
                            <td class="text-right">{{ formatMoney(item.deduction_value, 2) }}</td>
                        </tr>
                        <tr>
                            <td colspan="4">Итого начислено</td>
                            <td class="text-right">{{ formatMoney(result.payslip.sum_amount, 2) }}</td>
                            <td colspan="2">Итого удержано</td>
                            <td class="text-right">{{ formatMoney(result.payslip.deduction_amount, 2) }}</td>
                        </tr>
                        <tr>
                            <td colspan="4"><strong v-if="result.payslip.paid !== 0">Уже выплачено за период</strong>
                            </td>
                            <td class="text-right"><strong v-if="result.payslip.paid !== 0">{{
                                formatMoney(result.payslip.paid, 2)
                                }}</strong></td>
                            <td><strong>Итого к выплате</strong></td>
                            <td colspan="2" class="text-right"><strong>{{
                                formatMoney(result.payslip.amount, 2)
                                }}</strong></td>
                        </tr>
                        </tbody>
                    </table>

                    <template v-if="payslip.attachTranscript == 1">
                        <CalcDescription :data="result" :laws="false" :expand="true" :tableClass="''"
                                         :show_result="true"></CalcDescription>
                    </template>


                </div>


                <template v-slot:modal-footer="{cancel}">
                    <b-form-checkbox v-model="payslip.attachTranscript" value="1" unchecked-value="0">Прикрепить
                        расшифровку
                    </b-form-checkbox>
                    <b-button variant="primary" size="sm" @click="Print('printBodyRL', 'portrait')"><span
                            class="mdi mdi-printer"></span>
                        Печать
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span>
                        Закрыть
                    </b-button>
                </template>
            </b-modal>
            <!-- ОКНО Расчетный листок. Конец -->

            <!-- ОКНО Дополнительные параметры. Начало -->
            <b-modal header-bg-variant="primary" header-text-variant="white" size="xl" scrollable id="modal-params"
                     centered
                     ok-disabled
                     title="Дополнительные параметры расчета" cancel-title-html="Закрыть" button-size="sm">

                <p>Здесь собраны редко используемые и устаревшие параметры, которые перенесены с основного интерфейса,
                    чтобы не
                    мешать расчетам.</p>
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group>
                            <b-form-checkbox size="sm" v-model="params.adjustment" value="1" unchecked-value="0">
                                Автоматическое применение корректировки 90%
                            </b-form-checkbox>
                            <small class="text-muted form-text">Если отменить этот параметр, то корректировка не будет
                                применяться ни в
                                каком случае. При установленном параметре калькулятор будет сам определять, когда
                                применять
                                корректировку.</small>
                        </b-form-group>

                        <b-form-group>
                            <b-form-checkbox size="sm" v-model="params.adjustment_exception" value="1"
                                             unchecked-value="0">
                                Исключение корректировки 90% из расчета СН, ООСМС, ВОСМС
                            </b-form-checkbox>
                            <small class="text-muted form-text">Неактуальный параметр, так как в связи с изменениями в
                                законодательстве
                                от 10 декабря 2020 года исключать корректировку в 2020 году не потребовалось.</small>
                        </b-form-group>


                        <b-form-group>
                            <b-form-checkbox size="sm" v-model="params.fuck_new_layer" value="1" unchecked-value="0">
                                Не применять вычет ВОСМС при расчете ИПН для работников и не применять вычет ВОСМС и ОПВ
                                при расчете ИПН
                                по договору ГПХ
                            </b-form-checkbox>
                            <small class="text-muted form-text">Позволяет делать расчет начислений по договору ГПХ за
                                2018-2020 без
                                применения вычета ВОСМС и ОПВ при расчете ИПН</small>
                        </b-form-group>

                    </div>
                    <div class="col-md-6"></div>
                </div>

                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span>
                        Закрыть
                    </b-button>
                </template>
            </b-modal>
            <!-- ОКНО Дополнительные параметры. Конец -->

            <!-- ОКНО Заменить начисление. Начало -->
            <b-modal header-bg-variant="primary" header-text-variant="white" size="md" id="modal-force-add" centered
                     ok-disabled
                     title="Обновление расчета в базе данных" cancel-title-html="Закрыть" button-size="sm">
                Расчет за <strong class="text-danger">{{ getMonthName(period.month) }} {{ period.year }} года</strong>
                уже есть в
                ваших данных по зарплате. Хотите обновить информацию о расчете?

                <template v-slot:modal-footer="{cancel}">
                    <b-button variant="primary" size="sm" @click="addToRegister('force')"><span
                            class="mdi mdi-content-save"></span> Обновить
                        расчет
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Не
                        обновлять
                    </b-button>
                </template>
            </b-modal>
            <!-- ОКНО Заменить начисление. Конец -->


            <transition name="fade">
                <div v-show="resultWindow.show" :class="resultWindow.class" style="z-index: 501">
                    <div v-if="resultWindow.show" class="row">
                      <!--<div v-if="user.subscribe_expired" class="col-12">
                          <div  class="p-2 my-2 text-center bg-white">
                              <Adsense
                                  data-ad-client="ca-pub-0972485314380963"
                                  data-ad-slot="5801815779">
                              </Adsense>
                          </div>
                          <div class="p-2 my-2 text-center bg-warning">
                              Бесплатная версия калькулятора зарплаты существует благодаря вашим пожертвованиям. Примите посильное финансовое участие в поддержке и развитии сервиса.<br>
                              Номер для переводов Kaspi, Homebank, Jusan, Bereke bank: +7 701 842-2501 (Вадим С.). Переводы по номеру карты: 4405 6397 8894 5739 (Народный банк).<br>
                              При пожертвовании на сумму 10 000 тенге и выше – подписка на полную версию калькулятора сроком от 2 лет и более.
                          </div>

                      </div>
                      <div :class="resultWindow.colLeft">

                      </div>
                      <div :class="resultWindow.colRight">-->
                        <div class="col-12">
                            <div id="printBodyDesc" class="bg-white">

                                <CalcDescription :tableClass="''" :data="result" :laws="true" :tax="tax"
                                                 :expand="resultWindow.expand" :show_result="true"
                                                 :wait="this.$store.state.wait.state"
                                                 :month="getMonthName(period.month)"
                                                 :year="period.year">
                                    <template v-if="resultWindow.show">
                                        <b-button v-if="resultWindow.calcAgain" class="mr-1" variant="primary" size="sm" @click="Calculator()"
                                                  :disabled="this.$store.state.wait.state"><span
                                            class="mdi mdi-calculator"></span> Рассчитать заново
                                        </b-button>

                                        <b-button v-if="!resultWindow.expand" class="mr-1" @click="Expand(true)" variant="info"
                                                  size="sm"><span class="mdi mdi-arrow-expand"></span><span
                                            class="d-none d-md-inline"> Показать расшифровку</span>
                                        </b-button>


                                        <b-button v-if="resultWindow.expand" class="mr-1" variant="info" size="sm"
                                                  @click="Expand(false)"><span
                                            class="mdi mdi-arrow-collapse"></span><span class="d-none d-md-inline"> Свернуть расшифровку</span>
                                        </b-button>

                                        <b-button v-if="user.registered && !user.subscribe_expired" class="mr-1"
                                                  variant="success" size="sm"
                                                  @click="addToRegister()"
                                                  :disabled="!resultWindow.show"><span class="mdi mdi-content-save"></span><span
                                            class="d-none d-md-inline"> Сохранить расчет в начисления</span>
                                        </b-button>

                                        <b-button class="mr-1" variant="dark" size="sm" v-b-modal.modal-payslip
                                                  :disabled="!resultWindow.show"><span class="mdi mdi-printer"></span> Расчетный листок
                                        </b-button>

                                        <b-button class="mr-1" variant="dark" v-if="resultWindow.expand"
                                                  @click="Print('printBodyDesc', 'portrait')"
                                                  size="sm"><span class="mdi mdi-printer"></span> Печать расшифровки
                                        </b-button>
                                    </template>

                                    <b-button variant="danger" size="sm" class="ml-3" @click="resultWindow.show = false, resultWindow.init = false"><span
                                        class="mdi mdi-close"></span> Закрыть
                                    </b-button>

                                </CalcDescription>
                            </div>
                        </div>
                    </div>

                    <!--<div v-if="resultWindow.init" class="row">
                        <div class="col-12">
                            <div class="p-2 text-center">
                                <Adsense
                                    data-ad-client="ca-pub-0972485314380963"
                                    data-ad-slot="5801815779">
                                </Adsense>
                            </div>
                        </div>
                    </div>-->


                </div>
            </transition>


            <div class="container-fluid">

                <div v-if="!adBlock || !user.subscribe_expired" class="row">


                    <div class="col-md-4">
                        <!-- БЛОК Организация и сотрудник. Начало -->
                        <b-card header-bg-variant="secondary" header-text-variant="white"
                                header="Организация и сотрудник"
                                body-class="bg-green-light" class="border-0 mb-1">
                            <div class="row">
                                <div class="col-md-12 pt-1">
                                    <b-form-group>
                                        <SelectOrg :key="'org'" :title="['Организация', 'Организация']" :name="'orgs'"
                                                   :table="'reg_organizations'"
                                                   :fields="['name']"></SelectOrg>
                                    </b-form-group>
                                </div>

                                <div class="col-6">
                                    <b-form-group>
                                        <Enums :type="'enum'" :name="'orgtype'" v-model="org.type"></Enums>
                                    </b-form-group>

                                </div>
                                <div class="col-6">
                                    <b-form-group>
                                        <Enums :type="'enum'" :name="'orgmode'" v-model="org.mode"></Enums>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <b-form-group>
                                        <SelectWorker :title="['Сотрудник', 'Сотрудник']"></SelectWorker>
                                    </b-form-group>
                                </div>
                            </div>

                            <hr class="my-1">
                            <b-input-group size="sm" prepend="Рабочая неделя">
                                <Enums :key="'workweek'" :type="'enum'" :name="'workweeks'" v-model="period.week"
                                       @change="Period('worked', 'all')"></Enums>
                            </b-input-group>


                            <hr class="my-1">

                            <div class="row">
                                <div class="col-md-6">

                                    <b-form-checkbox size="sm" v-model="worker.citizen" value="1" unchecked-value="0">
                                        Гражданин РК
                                    </b-form-checkbox>

                                    <transition name="slide-fade">
                                        <b-form-checkbox size="sm" v-model="worker.residence_permit" value="1"
                                                         unchecked-value="0"
                                                         :disabled="disabled.residence_permit">Вид на жительство
                                        </b-form-checkbox>
                                    </transition>


                                    <!-- ПОЛЕ Иностранец резидент -->
                                    <transition name="slide-fade">
                                        <div id="foreigner_resident">
                                            <b-form-checkbox size="sm" v-model="worker.foreigner_resident" value="1"
                                                             unchecked-value="0"
                                                             :disabled="disabled.foreigner_resident">Иностранец-резидент
                                                согласно ст.217 НК РК
                                            </b-form-checkbox>
                                            <b-popover target="foreigner_resident" triggers="hover" placement="left">
                                                <template #title>Иностранец-резидент</template>
                                                В соответствии с положениями статьи 217 Налогового кодекса к
                                                иностранцам-резидентам в целях
                                                налогообложения относятся следующие категории иностранцев:
                                                1) Иностранец, который пребывает на территории Казахстана не менее 183
                                                календарных дней (включая
                                                дни приезда и отъезда) в любом 12-месячном периоде, оканчивающемся в
                                                текущем налоговом периоде
                                                (п. 2 ст. 217 НК);
                                                2) Иностранец, центр жизненных интересов которого находится в Казахстане
                                                (п. 3 ст. 217 НК);
                                                3) Иностранцы, подавшие заявление о приеме в гражданство РК или о
                                                разрешении на постоянное
                                                проживание в Республике Казахстан
                                            </b-popover>
                                        </div>
                                    </transition>


                                    <b-form-checkbox v-show="false" size="sm" v-model="worker.resident" value="1"
                                                     unchecked-value="0"
                                                     :disabled="disabled.resident">Резидент
                                    </b-form-checkbox>

                                    <transition name="slide-fade">
                                        <b-form-checkbox size="sm" v-model="worker.eaes_member" unchecked-value="0"
                                                         value="1"
                                                         :disabled="disabled.eaes_member">Член ЕАЭС
                                        </b-form-checkbox>
                                    </transition>

                                  <transition name="slide-fade">
                                    <b-form-checkbox size="sm" v-model="worker.remote_worker" unchecked-value="0"
                                                     value="1"
                                                     :disabled="disabled.remote_worker">Нерезидент дистанционник
                                    </b-form-checkbox>
                                  </transition>


                                    <b-form-checkbox size="sm" v-model="worker.main_work" value="1" unchecked-value="0">
                                        Основное место работы
                                    </b-form-checkbox>

                                    <transition name="slide-fade">
                                        <b-form-checkbox size="sm" v-model="worker.recoupment" value="1"
                                                         unchecked-value="0"
                                                         :disabled="disabled.recoupment">Стандартный вычет по ИПН
                                        </b-form-checkbox>
                                    </transition>

                                    <b-form-checkbox size="sm" v-model="worker.harmful_working_conditions" value="1"
                                                     unchecked-value="0">
                                        Вредные условия труда (ОППВ)
                                    </b-form-checkbox>


                                    <!--<b-form-checkbox v-show="true" size="sm" v-model="worker.civil_contract" value="1" unchecked-value="0" disabled>
                                      По договору ГПХ - теперь параметр нужно выбирать в типе начисления
                                    </b-form-checkbox>-->

                                    <b-form-checkbox size="sm" v-model="worker.other_income" value="1"
                                                     unchecked-value="0">
                                        Сотрудник имеет доход от другого работодателя
                                    </b-form-checkbox>

                                    <b-form-checkbox v-show="!disabled.owner" size="sm" v-model="worker.owner" value="1"
                                                     unchecked-value="0"
                                                     :disabled="disabled.owner">Владелец этого ИП
                                    </b-form-checkbox>

                                </div>


                                <div class="col-md-6">
                                    <h6>Категории работника</h6>

                                    <b-form-group>
                                        <Enums :key="'invalid'" :type="'enum'" :name="'invalid_group'"
                                               v-model="worker.invalid_group"></Enums>
                                    </b-form-group>


                                    <b-form-checkbox v-if="[1,2].includes(worker.invalid_group)" size="sm" v-model="params.will_opv" value="1" unchecked-value="0">
                                        Добровольное перечисление ОПВ за инвалида
                                    </b-form-checkbox>


                                    <b-form-checkbox size="sm" v-model="worker.pensioner" value="1" unchecked-value="0">
                                        Пенсионер по возрасту
                                    </b-form-checkbox>

                                    <b-form-checkbox size="sm" v-model="worker.pensioner_year" value="1"
                                                     unchecked-value="0">
                                        Пенсионер по выслуге лет
                                    </b-form-checkbox>


                                    <b-form-checkbox size="sm" v-model="worker.warrior" value="1" unchecked-value="0"
                                                     title="Лица, приравненные по льготам и гарантиям к участникам Великой Отечественной войны, участники боевых действий на территории других государств"
                                                     v-b-tooltip.hover.topright>
                                        Ветеран боевых действий
                                    </b-form-checkbox>

                                    <b-form-checkbox size="sm" v-model="worker.chernobyl" value="1" unchecked-value="0"
                                                     title="Ликвидатор последствий аварии на Чернобыльской атомной электростанции"
                                                     v-b-tooltip.hover.topright>
                                        Ликвидатор ПА ЧАЭС
                                    </b-form-checkbox>

                                    <b-form-checkbox size="sm" v-model="worker.student" value="1" unchecked-value="0"
                                                     title="Лица, обучающиеся по очной форме обучения в организациях среднего, технического и профессионального, послесреднего, высшего образования, а также послевузовского образования"
                                                     v-b-tooltip.hover.topright>
                                        Студент
                                    </b-form-checkbox>

                                    <b-form-checkbox size="sm" v-model="worker.mother" value="1" unchecked-value="0"
                                                     title="Многодетные матери, награжденные подвесками «Алтын алқа», «Кұміс алқа» или получившие ранее звание «Мать-героиня», а также награжденные орденами «Материнская слава» I и II степени"
                                                     v-b-tooltip.hover.topright>
                                        Многодетная мать
                                    </b-form-checkbox>

                                  <b-form-checkbox size="sm" v-model="worker.astana_hub" value="1" unchecked-value="0"
                                                   title="Для работников – резидентов (по трудовому договору) участников Технопарка Астана Хаб предусмотрено освобождение от индивидуального подоходного налога в соответствии с подпунктом 50 пункта 1 статьи 341 Кодекса Республики Казахстан «О налогах и других обязательных платежах в бюджет»"
                                                   v-b-tooltip.hover.topright>
                                    Участник Astana Hub
                                  </b-form-checkbox>

                                  <b-form-checkbox size="sm" v-model="params.opvr_payer" value="1" unchecked-value="0"
                                                   title="Работодатель обязан оплачивать ОПВ работодателя за работников, родившихся после 1 января 1975 года. (статья 251 Социального Кодекса РК)"
                                                   v-b-tooltip.hover.topright>
                                    Плательщик ОПВР
                                  </b-form-checkbox>

                                </div>
                            </div>

                            <hr class="my-1">
                            <b-form-checkbox size="sm" v-model="params.zero_rate" value="1" unchecked-value="0"
                                             :disabled="disabled.zero_rate">
                                Применить нулевую ставку к расчету заработной платы
                            </b-form-checkbox>

                        </b-card>
                        <!-- БЛОК Организация и сотрудник. Конец -->


                    </div>
                    <div class="col-md-8">
                        <!-- БЛОК Начисления. Начало -->

                        <b-card header-bg-variant="secondary" header-text-variant="white"
                                header="Начисления и удержания"
                                body-class="bg-green-light" class="border-0 mb-1">

                            <div class="mb-2">
                                <div class="row">
                                    <div class="col-md-6">

                                        <b-input-group size="sm" prepend="Период расчета">

                                            <Enums :key="'month'" :type="'enum'" :name="'months'" v-model="period.month"
                                                   @change="Period()"></Enums>

                                            <Enums :key="'year'" :type="'enum'" :name="'years'" v-model="period.year"
                                                   @change="Period()"></Enums>
                                        </b-input-group>

                                    </div>
                                    <div class="col-md-6"></div>
                                </div>
                            </div>


                            <table class="table table-sm table-bordered table-12 table-green">
                                <tr>
                                    <th width="35%">Тип начисления</th>
                                    <th width="30%">Период</th>
                                    <th width="10%">Дней/часов</th>
                                    <th width="20%">Значение</th>
                                    <th width="5%"></th>
                                </tr>

                                <tr>
                                    <td>
                                        <Enums :type="'local'" :name="'sums_primary'"
                                               v-model="worker.sum_type" :group="true" :state="validation.sum"></Enums>
                                    </td>
                                    <td>
                                        <b-input-group size="sm">
                                            <b-form-input type="date" v-model="period.sum_from"
                                                          v-show="!period.sum_disabled"></b-form-input>
                                            <b-form-input type="date" v-model="period.sum_to"
                                                          v-show="!period.sum_disabled"></b-form-input>
                                        </b-input-group>
                                    </td>
                                    <td>
                                        <b-form-input size="sm" type="number" v-model="period.sum_period"
                                                      v-show="!period.sum_disabled"></b-form-input>
                                    </td>
                                    <td>
                                        <b-input-group size="sm" :append="titles.sum_name">
                                            <b-form-input type="number" size="sm" v-model.number="worker.sum"
                                                          :state="validation.sum"></b-form-input>
                                        </b-input-group>

                                    </td>
                                    <td>

                                    </td>
                                </tr>

                                <tr v-if="additional.sum > 0 && additional.sum != worker.sum && additional.sum_full != worker.sum">
                                    <td>
                                        <p v-if="additional.sum == additional.sum_full" class="p-0 m-0">По данному типу
                                            начисления за указанный период есть сохраненный расчет
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum', additional.sum)">
                                                {{ additional.sum }}
                                            </button>
                                            тенге. Нажмите на сумму, для переноса ее в начисление.
                                        </p>
                                        <p v-else class="p-0 m-0">По данному типу начисления есть сохраненные расчеты
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum', additional.sum)">
                                                {{ additional.sum }}
                                            </button>
                                            тенге за расчетный месяц или
                                            <buttom class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum', additional.sum_full)">
                                                {{ additional.sum_full }}
                                            </buttom>
                                            тенге за весь период. Нажмите на необходимую сумму, которую нужно перенести
                                            в начисление.
                                        </p>
                                    </td>
                                </tr>

                                <transition name="slide-fade">
                                    <tr v-if="count.sum > 1">
                                        <td>
                                            <Enums :state="validation.sum1" :type="'local'" :name="'sums_secondary'"
                                                   v-model="worker.sum1_type" :group="true"></Enums>
                                        </td>
                                        <td>
                                            <b-input-group size="sm">
                                                <b-form-input type="date" v-model="period.sum1_from"
                                                              v-show="!period.sum1_disabled"></b-form-input>
                                                <b-form-input type="date" v-model="period.sum1_to"
                                                              v-show="!period.sum1_disabled"></b-form-input>
                                            </b-input-group>
                                        </td>
                                        <td>
                                            <b-form-input size="sm" type="number" v-model="period.sum1_period"
                                                          v-show="!period.sum1_disabled"></b-form-input>
                                        </td>
                                        <td>
                                            <b-input-group size="sm" :append="titles.sum1_name">
                                                <b-form-input :state="validation.sum1" type="number" step="0.01"
                                                              size="sm"
                                                              v-model.number="worker.sum1"></b-form-input>
                                            </b-input-group>


                                        </td>
                                        <td>
                                            <b-button v-if="count.sum == 2" size="sm" variant="danger" class="btn-block"
                                                      v-b-tooltip
                                                      title="Удалить это начисление"
                                                      @click="fieldsIncrDecr('-', 'sum')"><span
                                                    class="mdi mdi-delete"></span></b-button>
                                        </td>
                                    </tr>
                                </transition>

                                <tr v-if="count.sum > 1 && additional.sum1 > 0 && additional.sum1 != worker.sum1 && additional.sum1_full != worker.sum1">
                                    <td colspan="5">
                                        <p v-if="additional.sum1 == additional.sum1_full" class="p-0 m-0">По данному
                                            типу начисления за указанный период есть сохраненный расчет
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum1', additional.sum1)">
                                                {{ additional.sum1 }}
                                            </button>
                                            тенге. Нажмите на сумму, для переноса ее в начисление.
                                        </p>
                                        <p v-else class="p-0 m-0">По данному типу начисления есть сохраненные расчеты
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum1', additional.sum1)">
                                                {{ additional.sum1 }}
                                            </button>
                                            тенге за расчетный месяц или
                                            <buttom class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum1', additional.sum1_full)">
                                                {{ additional.sum1_full }}
                                            </buttom>
                                            тенге за весь период. Нажмите на необходимую сумму, которую нужно перенести
                                            в начисление.
                                        </p>
                                    </td>
                                </tr>

                                <transition name="slide-fade">
                                    <tr v-if="count.sum > 2">
                                        <td>
                                            <Enums :state="validation.sum2" :type="'local'" :name="'sums_secondary'"
                                                   v-model="worker.sum2_type" :group="true"></Enums>
                                        </td>
                                        <td>
                                            <b-input-group size="sm">
                                                <b-form-input type="date" v-model="period.sum2_from"
                                                              v-show="!period.sum2_disabled"></b-form-input>
                                                <b-form-input type="date" v-model="period.sum2_to"
                                                              v-show="!period.sum2_disabled"></b-form-input>
                                            </b-input-group>
                                        </td>
                                        <td>
                                            <b-form-input size="sm" type="number" v-model="period.sum2_period"
                                                          v-show="!period.sum2_disabled"></b-form-input>
                                        </td>
                                        <td>
                                            <b-input-group size="sm" :append="titles.sum2_name">
                                                <b-form-input :state="validation.sum2" type="number" size="sm"
                                                              v-model.number="worker.sum2"></b-form-input>
                                            </b-input-group>

                                        </td>
                                        <td>
                                            <b-button v-if="count.sum == 3" size="sm" variant="danger" class="btn-block"
                                                      v-b-tooltip
                                                      title="Удалить это начисление"
                                                      @click="fieldsIncrDecr('-', 'sum')"><span
                                                    class="mdi mdi-delete"></span></b-button>
                                        </td>
                                    </tr>

                                </transition>

                                <tr v-if="count.sum > 2 && additional.sum2 > 0 && additional.sum2 != worker.sum2 && additional.sum2_full != worker.sum2">
                                    <td colspan="5">
                                        <p v-if="additional.sum2 == additional.sum2_full" class="p-0 m-0">По данному
                                            типу начисления за указанный период есть сохраненный расчет
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum2', additional.sum2)">
                                                {{ additional.sum2 }}
                                            </button>
                                            тенге. Нажмите на сумму, для переноса ее в начисление.
                                        </p>
                                        <p v-else class="p-0 m-0">По данному типу начисления есть сохраненные расчеты
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum2', additional.sum2)">
                                                {{ additional.sum2 }}
                                            </button>
                                            тенге за расчетный месяц или
                                            <buttom class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum2', additional.sum2_full)">
                                                {{ additional.sum2_full }}
                                            </buttom>
                                            тенге за весь период. Нажмите на необходимую сумму, которую нужно перенести
                                            в начисление.
                                        </p>
                                    </td>
                                </tr>

                                <transition name="slide-fade">
                                    <tr v-if="count.sum > 3">
                                        <td>
                                            <Enums :state="validation.sum3" :type="'local'" :name="'sums_secondary'"
                                                   v-model="worker.sum3_type" :group="true"></Enums>
                                        </td>
                                        <td>
                                            <b-input-group size="sm">
                                                <b-form-input type="date" v-model="period.sum3_from"
                                                              v-show="!period.sum3_disabled"></b-form-input>
                                                <b-form-input type="date" v-model="period.sum3_to"
                                                              v-show="!period.sum3_disabled"></b-form-input>
                                            </b-input-group>
                                        </td>
                                        <td>
                                            <b-form-input size="sm" type="number" v-model="period.sum3_period"
                                                          v-show="!period.sum3_disabled"></b-form-input>
                                        </td>
                                        <td>
                                            <b-input-group size="sm" :append="titles.sum3_name">
                                                <b-form-input :state="validation.sum3" type="number" size="sm"
                                                              v-model.number="worker.sum3"></b-form-input>
                                            </b-input-group>

                                        </td>
                                        <td>
                                            <b-button v-if="count.sum == 4" size="sm" variant="danger" class="btn-block"
                                                      v-b-tooltip
                                                      title="Удалить это начисление"
                                                      @click="fieldsIncrDecr('-', 'sum')"><span
                                                    class="mdi mdi-delete"></span></b-button>
                                        </td>
                                    </tr>

                                </transition>

                                <tr v-if="count.sum > 3 && additional.sum3 > 0 && additional.sum3 != worker.sum3 && additional.sum3_full != worker.sum3">
                                    <td colspan="5">
                                        <p v-if="additional.sum3 == additional.sum3_full" class="p-0 m-0">По данному
                                            типу начисления за указанный период есть сохраненный расчет
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum3', additional.sum3)">
                                                {{ additional.sum3 }}
                                            </button>
                                            тенге. Нажмите на сумму, для переноса ее в начисление.
                                        </p>
                                        <p v-else class="p-0 m-0">По данному типу начисления есть сохраненные расчеты
                                            на сумму
                                            <button class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum3', additional.sum3)">
                                                {{ additional.sum3 }}
                                            </button>
                                            тенге за расчетный месяц или
                                            <buttom class="btn btn-sm btn-primary"
                                                    @click="setAdditionalCharges('sum3', additional.sum3_full)">
                                                {{ additional.sum3_full }}
                                            </buttom>
                                            тенге за весь период. Нажмите на необходимую сумму, которую нужно перенести
                                            в начисление.
                                        </p>
                                    </td>
                                </tr>
                            </table>

                            <transition name="slide-fade">
                                <table v-if="count.deduction > 0"
                                       class="table table-sm table-bordered table-12 table-green">
                                    <tr>
                                        <th colspan="3" width="75%">Тип удержания</th>
                                        <th width="20%">Значение</th>
                                        <th width="5%"></th>
                                    </tr>

                                    <transition name="slide-fade">
                                        <tr v-if="count.deduction > 0">
                                            <td colspan="3">
                                                <Enums :state="validation.deduction" :type="'local'"
                                                       :name="'deductions'"
                                                       v-model="worker.deduction_type"></Enums>
                                            </td>
                                            <td>
                                                <b-input-group size="sm"
                                                               :append="titles.deduction_name">
                                                    <b-form-input :state="validation.deduction" type="number" size="sm"
                                                                  v-model="worker.deduction"></b-form-input>
                                                </b-input-group>
                                            </td>
                                            <td>
                                                <b-button v-if="count.deduction == 1" size="sm" variant="danger"
                                                          class="btn-block" v-b-tooltip
                                                          title="Удалить это удержание"
                                                          @click="fieldsIncrDecr('-', 'deduction')"><span
                                                        class="mdi mdi-delete"></span></b-button>
                                            </td>
                                        </tr>
                                    </transition>

                                    <transition name="slide-fade">
                                        <tr v-if="count.deduction > 1">
                                            <td colspan="3">
                                                <Enums :state="validation.deduction1" :type="'local'"
                                                       :name="'deductions'"
                                                       v-model="worker.deduction1_type"></Enums>
                                            </td>
                                            <td>
                                                <b-input-group size="sm"
                                                               :append="titles.deduction1_name">
                                                    <b-form-input :state="validation.deduction1" type="number" size="sm"
                                                                  v-model="worker.deduction1"></b-form-input>
                                                </b-input-group>
                                            </td>
                                            <td>
                                                <b-button v-if="count.deduction == 2" size="sm" variant="danger"
                                                          class="btn-block" v-b-tooltip
                                                          title="Удалить это удержание"
                                                          @click="fieldsIncrDecr('-', 'deduction')"><span
                                                        class="mdi mdi-delete"></span></b-button>
                                            </td>
                                        </tr>
                                    </transition>

                                    <transition name="slide-fade">
                                        <tr v-if="count.deduction > 2">
                                            <td colspan="3">
                                                <Enums :state="validation.deduction2" :type="'local'"
                                                       :name="'deductions'"
                                                       v-model="worker.deduction1_type"></Enums>
                                            </td>
                                            <td>
                                                <b-input-group size="sm"
                                                               :append="titles.deduction2_name">
                                                    <b-form-input :state="validation.deduction2" type="number" size="sm"
                                                                  v-model="worker.deduction2"></b-form-input>
                                                </b-input-group>
                                            </td>
                                            <td>
                                                <b-button v-if="count.deduction == 3" size="sm" variant="danger"
                                                          class="btn-block" v-b-tooltip
                                                          title="Удалить это удержание"
                                                          @click="fieldsIncrDecr('-', 'deduction')"><span
                                                        class="mdi mdi-delete"></span></b-button>
                                            </td>
                                        </tr>
                                    </transition>

                                    <transition name="slide-fade">
                                        <tr v-if="count.deduction > 3">
                                            <td colspan="3">
                                                <Enums :state="validation.deduction3" :type="'local'"
                                                       :name="'deductions'"
                                                       v-model="worker.deduction3_type"></Enums>
                                            </td>
                                            <td>
                                                <b-input-group size="sm"
                                                               :append="titles.deduction3_name">
                                                    <b-form-input :state="validation.deduction3" type="number" size="sm"
                                                                  v-model="worker.deduction3"></b-form-input>
                                                </b-input-group>
                                            </td>
                                            <td>
                                                <b-button v-if="count.deduction == 4" size="sm" variant="danger"
                                                          class="btn-block" v-b-tooltip
                                                          title="Удалить это удержание"
                                                          @click="fieldsIncrDecr('-', 'deduction')"><span
                                                        class="mdi mdi-delete"></span></b-button>
                                            </td>
                                        </tr>
                                    </transition>

                                </table>
                            </transition>


                            <div class="text-right">
                                <transition name="slide-fade">
                                    <b-button v-if="count.sum < 4" size="sm" variant="primary" class="mr-1"
                                              @click="fieldsIncrDecr('+', 'sum')"><span class="mdi mdi-plus-box"></span>&nbsp;Ещё
                                        одно
                                        начисление
                                    </b-button>
                                </transition>
                                <transition name="slide-fade">
                                    <b-button v-if="count.deduction < 4" size="sm" variant="info"
                                              @click="fieldsIncrDecr('+', 'deduction')"><span
                                            class="mdi mdi-plus-box"></span>&nbsp;
                                        <template v-if="count.deduction == 0">Добавить удержание</template>
                                        <template v-else>Ещё одно удержание</template>
                                    </b-button>
                                </transition>
                            </div>

                            <hr class="my-1">
                            <div class="row">
                                <div class="col-7">
                                    <div style="font-size: 12px">
                                        Если в расчетном месяце сотруднику выплачивался аванс или другие выплаты,
                                        внесите сумму этих выплат
                                        в поле справа для более корректного формирования расчетного листка
                                    </div>
                                </div>
                                <div class="col-5">
                                    <b-input-group size="sm" prepend="Выплачено" append="тенге">
                                        <b-input v-model="params.paid" size="sm"></b-input>
                                    </b-input-group>
                                </div>
                            </div>
                        </b-card>
                        <!-- БЛОК Начисления. Конец -->


                        <div class="row">
                            <div class="col-7">
                                <!-- БЛОК Доходы из других источников. Начало -->
                                <transition name="fade">
                                    <b-card v-if="worker.other_income == 1" header-bg-variant="secondary"
                                            header-text-variant="white"
                                            header="Доходы работника из других источников" body-class="bg-green-light"
                                            class="border-0 mb-1 sticky-bottom">
                                        <div class="row">
                                            <div class="col-md-3">
                                                <b-form-input size="sm" type="number"
                                                              v-model="other_income.income"></b-form-input>
                                                <small class="form-text text-muted">Доход</small>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-input size="sm" type="number"
                                                              v-model="other_income.recoupment"></b-form-input>
                                                <small class="form-text text-muted">Примененный стандартный
                                                    вычет</small>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-input size="sm" type="number"
                                                              v-model="other_income.vosms"></b-form-input>
                                                <small class="form-text text-muted">Взносы ОСМС</small>
                                            </div>
                                            <div class="col-md-3">
                                                <b-form-input size="sm" type="number"
                                                              v-model="other_income.so"></b-form-input>
                                                <small class="form-text text-muted">Социальные отчисления</small>
                                            </div>
                                        </div>

                                    </b-card>
                                </transition>
                                <!-- БЛОК Доходы из других источников. Конец -->

                                <!-- БЛОК Вычеты. Начало -->
                                <b-card header-bg-variant="secondary" header-text-variant="white"
                                        header="Вычеты по индивидуальному подоходному налогу" body-class="bg-red-light"
                                        class="border-0 mb-1 sticky-bottom">
                                    <div class="row row-cols-5">
                                        <div class="col">
                                            <b-form-input type="number" size="sm"
                                                          v-model="recoupment.ipn.standard"></b-form-input>
                                            <small class="form-text text-muted">Стандартный</small>
                                        </div>
                                        <div class="col">
                                            <b-form-input type="number" size="sm" v-model="recoupment.ipn.standard2"
                                                          v-b-tooltip.focus
                                                          title="Стандартный вычет 882 МРП"></b-form-input>
                                            <small class="form-text text-muted">Вычет 882МРП</small>
                                        </div>
                                        <div class="col">
                                            <b-form-input type="number" size="sm"
                                                          v-model="recoupment.ipn.other"></b-form-input>
                                            <small class="form-text text-muted">Прочие вычеты</small>
                                        </div>
                                        <div class="col">
                                            <b-form-input type="number" size="sm"
                                                          v-model="recoupment.ipn.last"></b-form-input>
                                            <small class="form-text text-muted">Перенос вычета</small>
                                        </div>
                                        <div class="col">
                                            <b-form-input type="number" size="sm" v-model="recoupment_total"
                                                          readonly></b-form-input>
                                            <small class="form-text text-muted">Общий вычет</small>
                                        </div>
                                    </div>
                                </b-card>
                                <!-- БЛОК Вычеты. Конец -->

                            </div>
                            <div class="col-5">
                                <!-- БЛОК Налоги. Начало -->
                                <b-card header-bg-variant="secondary" header-text-variant="white"
                                        header="Налоги" body-class="bg-red-light"
                                        class="border-0 mb-1 sticky-bottom">
                                    <div class="row">
                                        <div class="col-8">
                                            <div style="font-size: .8rem">
                                                Вы можете по желанию отключить тот или иной вид налога, взноса или
                                                отчисления, если в определенной
                                                ситуации нужно произвести расчет зарплаты без этих параметров
                                            </div>

                                        </div>
                                        <div class="col-4">
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="tax.opv">
                                                ОПВ
                                            </b-form-checkbox>

                                          <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="tax.opvr">
                                            ОПВР
                                          </b-form-checkbox>
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="tax.oppv">
                                                ОППВ
                                            </b-form-checkbox>
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="tax.ipn">
                                                ИПН
                                            </b-form-checkbox>
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="tax.sn">
                                                СН
                                            </b-form-checkbox>
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0" v-model="tax.so">
                                                СО
                                            </b-form-checkbox>
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0"
                                                             v-model="tax.oosms">ООСМС
                                            </b-form-checkbox>
                                            <b-form-checkbox size="sm" value="1" unchecked-value="0"
                                                             v-model="tax.vosms">ВОСМС
                                            </b-form-checkbox>
                                        </div>
                                    </div>

                                </b-card>
                                <!-- БЛОК Налоги. Конец -->
                            </div>
                        </div>

                    </div>
                </div>

                <div v-else class="text-center">
                    <h2>Ваш браузер блокирует рекламу на этом сайте</h2>
                    <div class="row">
                        <div class="col-3"></div>
                        <div class="col-6 text-left">
                            <p>Данный сайт существует благодаря рекламе, которая размещена на этой странице.</p>
                            <p>Для того, чтобы вы могли воспользоваться калькулятором зарплаты, пожалуйста, отключите блокировщик рекламы (AdBlock или другой) на этом сайте.</p>

                        </div>
                        <div class="col-3"></div>
                    </div>
                </div>


                <!--<Adsense
                    data-ad-client="ca-pub-0972485314380963"
                    data-ad-slot="5801815779"
                    data-ad-format="auto"
                    data-full-width-responsive="true">
                </Adsense>-->


            </div>

        </b-overlay>
    </div>
</template>

<script>
import Enums from "@/components/base/Enums";
import SelectOrg from "@/components/base/SelectOrg";
import SelectWorker from "@/components/base/SelectWorker";
import ControlPanel from "@/components/base/ControlPanel"
import CalcDescription from "@/components/base/Description"
import {mapGetters} from 'vuex';
import { detectAnyAdblocker } from 'vue-adblock-detector'

export default {
    name: 'CalcMain',
    components: {
        Enums,
        SelectOrg,
        SelectWorker,
        ControlPanel,
        CalcDescription
    },
    data: function () {
        return {
            links: [
                {name: 'Сохраненные начисления зарплаты', link: '/salary/sums/', icon: 'mdi mdi-view-list'},
                {
                    name: 'Калькулятор отпускных/больничных/компенсации',
                    link: '/salary/additionalcharges/',
                    icon: 'mdi mdi-calculator'
                },
                {name: 'Справочники', link: '/registers', icon: 'mdi mdi-format-list-bulleted'},
                {name: 'Документы', link: '/docs/', icon: 'mdi mdi-file'},
                {name: 'Отчёты', link: '/reports/', icon: 'mdi mdi-format-list-numbered'},
            ],
            ads: false,
            validation: {
                sum: null,
                sum1: null,
                sum2: null,
                sum3: null,
                deduction: null,
                deduction1: null,
                deduction2: null,
                deduction3: null
            },
            count: {
                sum: 1,
                deduction: 0
            },
            iface: {
                view: 'old',
                blocks: {
                    control: {
                        help: false
                    },
                    sum: {
                        help: false
                    },
                    deduction: {
                        help: false
                    },
                    period: {
                        help: false
                    },
                    org: {
                        help: false
                    },
                    worker: {
                        help: false
                    },
                    recoupments: {
                        help: false
                    },
                    tax: {
                        help: false
                    },
                    params: {
                        help: false
                    }
                }
            },
            vacation: {}, //!!!
            params_blocker: false,
            payslip: {
                attachTranscript: 0
            },
            expand: {
                showCalc: false,
                showButton: false,
                weight: 'col-md-2',
                weightNew: 'col-md-3',
                bordered: ''
            },
            show_result: false,
            titles: {
                sum_name: '',
                sum1_name: '',
                sum2_name: '',
                sum3_name: '',
                deduction_name: '',
                deduction1_name: '',
                deduction2_name: '',
                deduction3_name: ''
            },

            period: {
                month: '01',
                year: new Date().getFullYear(),
                week: '40_5',
                days: 0,
                hours: 0,
                from: '',
                to: '',
                sum_from: '',
                sum_to: '',
                sum_period: 0,
                sum_disabled: true,
                sum_mode: '',
                sum_changed: 0,
                sum1_from: '',
                sum1_to: '',
                sum1_period: 0,
                sum1_disabled: true,
                sum1_mode: '',
                sum1_changed: 0,
                sum2_from: '',
                sum2_to: '',
                sum2_period: 0,
                sum2_disabled: true,
                sum2_mode: '',
                sum2_changed: 0,
                sum3_from: '',
                sum3_to: '',
                sum3_period: 0,
                sum3_disabled: true,
                sum3_mode: '',
                sum3_changed: 0,
            },
            params: {
                change: 0,
                citizen: '',
                adjustment: 1,
                paid: 0,
                adjustment_exception: 0,
                sum_feature: '',
                sum1_feature: '',
                sum2_feature: '',
                sum3_feature: '',
                zero_rate: 0,
                fuck_new_layer: 0,
                round: 1,
                mrp_year: 0,
                will_opv: 0,
              opvr_payer: 1,
            },
            zero_rate: {
                name: '',
                opv: 0,
                opvr: 0,
                oppv: 0,
                ipn: 0,
                sn: 0,
                so: 0,
                oosms: 0,
                vosms: 0
            },
            tax: {
                opv: 1,
                opvr: 1,
                oppv: 1,
                ipn: 1,
                sn: 1,
                so: 1,
                oosms: 1,
                vosms: 1
            },
            recoupment: {
                ipn: {
                    standard: 0,
                    other: 0,
                    standard2: 0,
                    last: 0
                }
            },
            indices: {},
            regl: [],
            calendar: {},
            other_income: {
                id: 0,
                income: 0,
                recoupment: 0,
                vosms: 0,
                so: 0
            },
            result: {
                sum: 0,
                worker: 0,
                employer: 0,
                adjustment: 0,
                deduction: 0,
                opv: 0,
                opvr: 0,
                oppv: 0,
                ipn: 0,
                sn: 0,
                so: 0,
                vosms: 0,
                oosms: 0
            },
            disabled: {
                resident: false,
                residence_permit: false,
                foreigner_resident: false,
                eaes_member: false,
                recoupment: false,
                owner: false,
                days: false,
                hours: false,
                zero_rate: false,
                sum: false,
                sum1: false,
                sum2: false,
                sum3: false
            },
            additional: {
                sum: 0,
                sum_full: 0,
                sum1: 0,
                sum1_full: 0,
                sum2: 0,
                sum2_full: 0,
                sum3: 0,
                sum3_full: 0
            },
            timeout: {},
            debug: {},

            resultWindow: {
                init: true,
                show: false,
                calcAgain: false,
                expand: false,
                class: 'fixed-bottom bg-light w-100 mb-1 p-1 shadow border',
                colRight: 'col-12 col-md-6',
                colLeft: 'd-none d-md-block col-12 col-md-6',
            },
            adBlock: false
        }
    },
    methods: {

        checkFieldsCounter: function () {
            if (this.worker.id != 0) {
                // Изменение счетчиков
                this.count.sum = 1;
                if (this.worker.sum1 != 0 || this.worker.sum1_type != 0) {
                    this.count.sum = 2;
                }
                if (this.worker.sum2 != 0 || this.worker.sum2_type != 0) {
                    this.count.sum = 3;
                }
                if (this.worker.sum3 != 0 || this.worker.sum3_type != 0) {
                    this.count.sum = 4;
                }

                this.count.deduction = 0;
                if (this.worker.deduction != 0 || this.worker.deduction_type != 0) {
                    this.count.deduction = 1;
                }
                if (this.worker.deduction1 != 0 || this.worker.deduction1_type != 0) {
                    this.count.deduction = 2;
                }
                if (this.worker.deduction2 != 0 || this.worker.deduction2_type != 0) {
                    this.count.deduction = 3;
                }
                if (this.worker.deduction3 != 0 || this.worker.deduction3_type != 0) {
                    this.count.deduction = 4;
                }

                // Валидация
                this.worker.sum != 0 && this.worker.sum_type != 0 ? this.validation.sum = true : this.validation.sum = false;
                this.worker.sum1 != 0 && this.worker.sum1_type != 0 ? this.validation.sum1 = true : this.validation.sum1 = null;
                this.worker.sum2 != 0 && this.worker.sum2_type != 0 ? this.validation.sum2 = true : this.validation.sum2 = null;
                this.worker.sum3 != 0 && this.worker.sum3_type != 0 ? this.validation.sum3 = true : this.validation.sum3 = null;
                this.worker.deduction != 0 && this.worker.deduction_type != 0 ? this.validation.deduction = true : this.validation.deduction = null;
                this.worker.deduction1 != 0 && this.worker.deduction1_type != 0 ? this.validation.deduction1 = true : this.validation.deduction1 = null;
                this.worker.deduction2 != 0 && this.worker.deduction2_type != 0 ? this.validation.deduction2 = true : this.validation.deduction2 = null;
                this.worker.deduction3 != 0 && this.worker.deduction3_type != 0 ? this.validation.deduction3 = true : this.validation.deduction3 = null;
            }
        },
        // Удаление или добавление поля
        fieldsIncrDecr: function (mode, field) {
            switch (mode) {
                case '+':
                    this.count[field] += 1;
                    break;
                case '-':
                    this.count[field] -= 1;
                    break;
            }

            let prefix = this.count[field];
            if (prefix == 0) {
                prefix = '';
            }
            if (mode == '-') {
                this.worker[field + prefix] = 0;
                this.worker[field + prefix + '_type'] = 0;
            }

        },

        // МЕТОД Добавление дополнительного начисления в поле
        setAdditionalCharges: function (field, sum) {
            this.worker[field] = sum;
        },

        // МЕТОД Период
        Period: function (mode, field) {
            this.$store.commit('wait', {state: true, name: 'Загрузка данных периода'});

            this.$http
                .post(this.$apiold, {
                    task: 'calendar',
                    mode: mode,
                    period: this.period,
                    sum_types: this.$store.getters.sumTypes,
                    field: field

                })
                .then(response => {

                    this.$store.commit('wait', {state: false});

                    if (!response.data.error) {
                        switch (mode) {
                            default:
                                Object.assign(this.indices, response.data.result.indices);
                                Object.assign(this.calendar, response.data.result.calendar);
                                this.debug = response.data.result.debug;
                                Object.assign(this.period, response.data.result.period);

                                break;
                            case 'period':
                                Object.assign(this.period, response.data.result.period);
                                break;
                        }
                    }
                    this.$store.commit('alert', response.data.messages);

                })
                .then(() => {
                    this.Params()
                })
                .catch(() => {
                    //alert (error)
                })

        },

        // МЕТОД Добавление в регистр
        addToRegister: function (mode) {
            this.$store.commit('wait', {state: true, name: 'Сохранение данных по зарплате'});
            this.$http
                .post(this.$apiold, {
                    task: 'salary-add-to-register',
                    data: this.calc,
                    result: this.result,
                    mode: mode
                })
                .then(response => {
                    this.$store.commit('wait', {state: false});

                    this.$store.commit('user', response.data.user);

                    if (!response.data.error) {
                        // Регистрируем изменение для обновления реестра
                        this.$store.commit('changeRegister');
                    }

                    // Открываем окно
                    if (response.data.force) {
                        this.$bvModal.show('modal-force-add');
                    } else {
                        this.$bvModal.hide('modal-force-add');
                    }

                    // Сообщения
                    this.$store.commit('alert', response.data.messages);
                });
        },

        Register: function () {
            this.$bvModal.show('modal-regl');
        },

        // МЕТОД Развернуть результаты расчета
        Expand: function (mode) {
            switch (mode) {
                case true:
                    this.resultWindow.expand = true
                    this.resultWindow.class = 'fixed-bottom bg-light w-100 p-1 shadow '
                    this.resultWindow.colRight = 'col-12 col-md-8'
                    this.resultWindow.colLeft = 'd-none d-md-block col-12 col-md-4'
                    break;
                case false:
                    this.resultWindow.expand = false
                    this.resultWindow.class = 'fixed-bottom bg-light w-100 p-1 shadow '
                    this.resultWindow.colRight = 'col-12 col-md-6'
                    this.resultWindow.colLeft = 'd-none d-md-block col-12 col-md-6'
                    break;
            }
        },

        // МЕТОД Калькулятор
        async Calculator() {

            await this.checkFieldsCounter();

            this.$store.commit('wait', {state: true, name: 'Расчет зарплаты'});
            this.show_result = false;

            this.Expand(false);

            await this.$http
                .post(this.$apiold, {
                    task: 'salary-calc',
                    data: this.calc
                })
                .then(response => {
                    if (!response.data.error) {
                        this.result = response.data.result;
                    }
                    this.$store.commit('wait', {state: false});
                    this.$store.commit('user', response.data.user);

                    if (!response.data.error) {
                        this.resultWindow.show = true;
                        this.resultWindow.init = false;
                        this.$bvModal.show('modal-result');

                    }

                    this.payslip.attachTranscript = 0;

                    // Сообщения
                    this.$store.commit('alert', response.data.messages);

                    if (this.user.subscribe_expired) {
                      this.$bvModal.show('modal-unsubscribed');
                    }

                });
        },

      async doSS(price) {
        this.$store.commit('wait', {state: true});
        await this.$http
            .post(this.$apiold, {
              task: 'ss',
              user_id: this.user.id,
              price: price,
            })
            .then(response => {
              this.$store.commit('wait', {state: false});
              this.$store.commit('alert', response.data.messages);
              //this.$bvModal.hide('modal-selfsubscribed');
            })
      },

      modalSelf: function () {
        this.$bvModal.hide('modal-unsubscribed');
        //this.$bvModal.show('modal-selfsubscribed');
          },
        async Params(mode) {
            if (!this.params_blocker) {
                //this.params_blocker = true;
                this.$store.commit('wait', {state: true, name: 'Обработка параметров для расчета зарплаты'});
                this.resultWindow.show = false;

                await this.$http
                    .post(this.$apiold, {
                        task: 'salary-params',
                        worker: this.worker,
                        org: this.org,
                        period: this.period,
                        tax: this.tax,
                        recoupment: this.recoupment,
                        params: this.params,
                        indices: this.indices
                    })
                    .then(response => {
                        this.$store.commit('wait', {state: false});

                        this.$store.commit('user', response.data.user);

                        let result = response.data.result;

                        if (this.$refs.resultCarousel) {
                            this.$refs.resultCarousel.setSlide(0);
                        }


                        // Регламентированные расчетные показатели
                        //this.indices = result.values.indices;


                        this.disabled = result.disabled;


                        // Налоги
                        //this.tax = result.values.tax; убрал, чтобы не изменялся параметр, так как он все равно не меняется

                        if (mode == 'worker') {

                            this.worker.owner = result.values.owner;
                            this.worker.civil_contract = result.values.civil_contract;


                            this.worker.resident = result.values.resident;
                            this.worker.residence_permit = result.values.residence_permit;
                            this.worker.foreigner_resident = result.values.foreigner_resident;
                            this.worker.eaes_member = result.values.eaes_member;
                            this.worker.remote_worker = result.values.remote_worker;

                            //if (this.worker.recoupment != result.values.recoupment) {
                            this.worker.recoupment = result.values.recoupment;
                            //}


                            // Начисления и удержания
                            this.titles.sum_name = result.values.sum_name;
                            this.titles.sum1_name = result.values.sum1_name;
                            this.titles.sum2_name = result.values.sum2_name;
                            this.titles.sum3_name = result.values.sum3_name;
                            this.titles.deduction_name = result.values.deduction_name;
                            this.titles.deduction1_name = result.values.deduction1_name;
                            this.titles.deduction2_name = result.values.deduction2_name;
                            this.titles.deduction3_name = result.values.deduction3_name;

                            this.params.sum_feature = result.values.sum_feature;
                            this.params.sum1_feature = result.values.sum1_feature;
                            this.params.sum2_feature = result.values.sum2_feature;
                            this.params.sum3_feature = result.values.sum3_feature;

                            if (result.values.sum1 != 0) {
                                this.worker.sum1 = result.values.sum1;
                            }
                            if (result.values.sum2 != 0) {
                                this.worker.sum2 = result.values.sum2;
                            }
                            if (result.values.sum3 != 0) {
                                this.worker.sum3 = result.values.sum3;
                            }

                            if (result.values.deduction != 0) {
                                this.worker.deduction = result.values.deduction;
                            }
                            if (result.values.deduction1 != 0) {
                                this.worker.deduction1 = result.values.deduction1;
                            }
                            if (result.values.deduction2 != 0) {
                                this.worker.deduction2 = result.values.deduction2;
                            }
                            if (result.values.deduction3 != 0) {
                                this.worker.deduction3 = result.values.deduction3;
                            }
                        }
                        // Стандартный вычет по ИПН
                        this.recoupment.ipn.standard = result.values.recoupmentipn.standard;

                        // Вычет 882
                        this.recoupment.ipn.standard2 = result.values.recoupmentipn.standard2;

                        // Прочие вычеты по ИПН
                        this.recoupment.ipn.other = result.values.recoupmentipn.other;

                        // Перенос вычета по ИПН
                        this.recoupment.ipn.last = result.values.recoupmentipn.last;

                        // Корректировка 90%
                        //this.params.adjustment = result.values.adjustment;

                        // Нулевая ставка
                        this.zero_rate = result.values.zero_rate;
                        if (result.disabled.zero_rate) {
                            this.params.zero_rate = 0;
                        }

                        this.regl = result.values.regl


                    })
                    .then(() => {
                        this.getAddidionalSums() // Проверяем есть ли дополнительные начисления для данного типа начисления за период по сотруднику
                    })
                    .catch(() => {
                        this.Params()
                    })
            }
        },
        // МЕТОД Параметры


        getAddidionalSums: function () {
            if (this.workers.list.length > 0 && this.worker) {
                this.$store.commit('wait', {state: true, name: 'Поиск результатов дополнительных расчетов'});
                this.$http
                    .post(this.$apiold, {
                        task: 'salary-get-additional-sum',
                        period: this.period,
                        org: this.org,
                        worker: this.worker
                    })
                    .then(response => {
                        this.$store.commit('wait', {state: false});

                        this.$store.commit('user', response.data.user);

                        // Сообщения
                        this.$store.commit('alert', response.data.messages);
                        this.additional = response.data.result.additional
                    })
            }

        }

    },
    created: function () {

        this.setOrgs();
        this.Period();
        this.Period('date', 'sum')
        this.Period('date', 'sum1')
        this.Period('date', 'sum2')
        this.Period('date', 'sum3')



    },
    mounted() {

    },
    beforeMount() {
        detectAnyAdblocker().then((detected) => {
            console.log(detected)
            if(detected){
                this.adBlock = true
            }
        });
    },
    computed: {
        ...mapGetters({
            user: 'user',
            org: 'org',
            workers: 'workers',
            worker: 'worker'
        }),


        calc: {
            get() {
                return this.$store.getters.calcData(this.params, this.period, this.org, this.worker, this.recoupment, this.indices, this.tax, this.calendar, this.vacation, this.zero_rate, this.other_income);
            }
        },
        recoupment_total: {
            get() {
                return parseInt(this.recoupment.ipn.standard) + parseInt(this.recoupment.ipn.other) + parseInt(this.recoupment.ipn.last);
            }
        }

    },
    watch: {
        'worker.sum_type': function () {
            this.Period('date', 'sum')
        },
        'worker.sum1_type': function () {
            this.Period('date', 'sum1')
        },
        'worker.sum2_type': function () {
            this.Period('date', 'sum2')
        },
        'worker.sum3_type': function () {
            this.Period('date', 'sum3')
        },

        'period.sum_from': function () {
            this.Period('worked', 'sum')
        },
        'period.sum_to': function () {
            this.Period('worked', 'sum')
        },
        'period.sum_mode': function () {
            this.Period('worked', 'sum')
        },
        'period.sum1_from': function () {
            this.Period('worked', 'sum1')
        },
        'period.sum1_to': function () {
            this.Period('worked', 'sum1')
        },
        'period.sum1_mode': function () {
            this.Period('worked', 'sum1')
        },
        'period.sum2_from': function () {
            this.Period('worked', 'sum2')
        },
        'period.sum2_to': function () {
            this.Period('worked', 'sum2')
        },
        'period.sum2_mode': function () {
            this.Period('worked', 'sum2')
        },
        'period.sum3_from': function () {
            this.Period('worked', 'sum3')
        },
        'period.sum3_to': function () {
            this.Period('worked', 'sum3')
        },
        'period.sum3_mode': function () {
            this.Period('worked', 'sum3')
        },

        worker: {
            handler: function () {
                this.worker.sum == '' ? this.worker.sum = 0 : this.worker.sum = parseFloat(this.worker.sum);
                this.worker.sum1 == '' ? this.worker.sum1 = 0 : this.worker.sum1 = parseFloat(this.worker.sum1);
                this.worker.sum2 == '' ? this.worker.sum2 = 0 : this.worker.sum2 = parseFloat(this.worker.sum2);
                this.worker.sum3 == '' ? this.worker.sum3 = 0 : this.worker.sum3 = parseFloat(this.worker.sum3);

                this.worker.deduction == '' ? this.worker.deduction = 0 : this.worker.deduction = parseFloat(this.worker.deduction);
                this.worker.deduction1 == '' ? this.worker.deduction1 = 0 : this.worker.deduction1 = parseFloat(this.worker.deduction1);
                this.worker.deduction2 == '' ? this.worker.deduction2 = 0 : this.worker.deduction2 = parseFloat(this.worker.deduction2);
                this.worker.deduction3 == '' ? this.worker.deduction3 = 0 : this.worker.deduction3 = parseFloat(this.worker.deduction3);


                // Если галочка других доходов отключена, то обнуляем доходы
                if (this.worker.other_income == 0) {
                    this.other_income.income = 0;
                    this.other_income.recoupment = 0;
                    this.other_income.so = 0;
                    this.other_income.vosms = 0;
                }

                this.checkFieldsCounter();

                var _this = this;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    _this.Params('worker')
                }, 500);

            },
            deep: true
        },
        tax: {
            handler: function () {
                this.resultWindow.calcAgain = true;
            },
            deep: true
        },
        org: {
            handler: function () {
                var _this = this;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    _this.Params()
                }, 200);

            },
            deep: true
        },
        recoupment: {
            handler: function () {
                this.recoupment.ipn.standard == '' ? this.recoupment.ipn.standard = 0 : this.recoupment.ipn.standard = parseFloat(this.recoupment.ipn.standard);
                this.recoupment.ipn.other == '' ? this.recoupment.ipn.other = 0 : this.recoupment.ipn.other = parseFloat(this.recoupment.ipn.other);
                this.recoupment.ipn.last == '' ? this.recoupment.ipn.last = 0 : this.recoupment.ipn.last = parseFloat(this.recoupment.ipn.last);
            },
            deep: true
        },
        period: {
            handler: function () {
                this.period.days == '' ? this.period.days = 0 : this.period.days = parseInt(this.period.days);
                this.period.hours == '' ? this.period.hours = 0 : this.period.hours = parseInt(this.period.hours);
            },
            deep: true
        },
        params: {
            handler: function () {
                this.$store.commit('mode', this.params.mode);
                this.Params('params');
                this.params.paid == '' ? this.params.paid = 0 : this.params.paid = parseFloat(this.params.paid);
            },
            deep: true
        },
        other_income: {
            handler: function () {
                this.other_income.income == '' ? this.other_income.income = 0 : this.other_income.income = parseInt(this.other_income.income);
                this.other_income.recoupment == '' ? this.other_income.recoupment = 0 : this.other_income.recoupment = parseInt(this.other_income.recoupment);
                this.other_income.so == '' ? this.other_income.so = 0 : this.other_income.so = parseInt(this.other_income.so);
                this.other_income.vosms == '' ? this.other_income.vosms = 0 : this.other_income.vosms = parseInt(this.other_income.vosms);

                var _this = this;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(function () {
                    _this.Params('other_income')
                }, 500);

            },
            deep: true
        }
    }
}
</script>

<style>

</style>
